import React from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useThemeStyles } from '../context/ThemeContext';

export const PAGE_SEARCH_MAX_WIDTH = 560;

/**
 * Page-level search field below the heading (icon prefix only, no search button).
 */
export default function PageSearchInput({
  placeholder = 'Search...',
  value,
  onChange,
  onClear,
  maxWidth = PAGE_SEARCH_MAX_WIDTH,
  style,
  inputStyle,
  ...rest
}) {
  const themeStyles = useThemeStyles();

  return (
    <div style={{ marginBottom: 16, width: '100%', ...style }}>
      <Input
        placeholder={placeholder}
        prefix={<SearchOutlined style={{ color: themeStyles.textTertiary }} />}
        allowClear
        value={value}
        onChange={onChange}
        onClear={onClear}
        style={{ width: '100%', maxWidth, ...inputStyle }}
        {...rest}
      />
    </div>
  );
}
